// extracted by mini-css-extract-plugin
module.exports = {"typeSelect":"Filter_typeSelect_P_o-l"};